const config = {
    apiGateway: {
        REGION: "us-east-1",
        URL: "https://q8ye948ddl.execute-api.us-east-1.amazonaws.com/prod/"
    },
    s3: {
        REGION: "us-east-1",
        BUCKET: "hit-uploads"
    },
    cognito: {
        REGION: 'us-east-1',
        USER_POOL_ID: 'us-east-1_teHXXHhMr',
        APP_CLIENT_ID: '328gtvuapi0o48tcpqrdrbgvfp',
        IDENTITY_POOL_ID: 'us-east-1:c77ba7c3-63c6-4b83-8dde-92d75f14964d'
    }
}

export default config
